<script setup lang="ts">

const props = defineProps<{
  ImageUrl: any;
}>();

const ImageUrl = props.ImageUrl

</script>

<template>
  <div class="product-popup">
    <NuxtImg provider="ipx" format="webp" loading="lazy" class="popup-image" :src="ImageUrl" alt="" />
  </div>
</template>